// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1XRnm","title":"InfoRow_title__3BxS8"};